export const style = {
  card: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'end',
    backgroundColor: 'gray.100',
    paddingX: 7,
    paddingY: 5,
    borderRadius: 10,
  },
  text: {
    fontWeight: 'bold',
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
};
